export default function random<T = unknown>(array: Array<T>) {
  return array[Math.floor(Math.random() * array.length)];
}
